export const exitSearchTitle = "IOFH$c";
export const suggestionsAnnouncementSingular = "dVr7_d";
export const suggestionsAnnouncementPlural = "G3bqwe";
export const searchButtonTitle = "YITPCc";
export const searchTooltipTitle = "v8Q3$c";
export default {exitSearchTitle,suggestionsAnnouncementSingular,suggestionsAnnouncementPlural,searchButtonTitle,searchTooltipTitle};